module.exports = "/images/Trec.png?31856396053d3875cf423293819f52a8";